import { createFileRoute } from '@tanstack/react-router'

import WriteUserAdminPage from '@/components/pages/backoffice/_user/_admin/containers/WriteUserAdminPage'

export const Route = createFileRoute('/_backoffice/user/admin/create')({
  component: WriteUserAdminPage
})
